import Init from "./init.page";

export default Init;
